module.exports = __webpack_public_path__ + "static/media/logoLi.c3dd725c.png";